import { QrCode } from 'lucide-react';
import { Button } from 'src/components/ui/button';
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from 'src/components/ui/dialog';
import { useAddressParam } from 'src/hooks/routing/useAddressParam';
import { useRef } from 'react';
import QRCode from 'qrcode';
import { CopyButton } from 'src/components/ui/copy-button';

export const AddressQRCode = () => {
  const address = useAddressParam();
  const canvasRef = useRef<HTMLCanvasElement>(null);

  const generateQRCode = () => {
    if (canvasRef.current && address) {
      QRCode.toCanvas(
        canvasRef.current,
        address,
        {
          width: 256, // 64 * 4 for good quality
          margin: 1,
          color: {
            dark: '#000000',
            light: '#FFFFFF',
          },
        },
        (error) => {
          if (error) {
            console.error('Error generating QR code:', error);
          }
        },
      );
    }
  };

  return (
    <Dialog
      onOpenChange={(open) => {
        if (open) {
          setTimeout(generateQRCode, 0);
        }
      }}
    >
      <DialogTrigger asChild>
        <Button variant="ghost" size="icon" className="h-6 w-6 p-0">
          <QrCode className="h-3.5 w-3.5 text-muted-foreground" />
        </Button>
      </DialogTrigger>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>Address QR Code</DialogTitle>
        </DialogHeader>
        <div className="flex flex-col items-center justify-center p-4">
          <div className="flex items-center justify-center text-sm">
            <div>{address}</div>
            <CopyButton text={address} />
          </div>
          <div className="rounded-lg bg-background">
            <canvas
              ref={canvasRef}
              className="h-64 w-64 rounded-lg"
              style={{ imageRendering: 'pixelated' }}
            />
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
};
